import { createAsyncThunk } from '@reduxjs/toolkit'
import { getMyBetsService, placeBetFlipCoinGameService } from '../services/flipCoin.service'
import { startFlip } from '../GameTheme/FlipCoinGame/pixi-js-scripts/bridge'
import { openSuccessToaster } from 'helpers/toaster.helpers'
import { flipCoinDemoPlaceBetHelper } from '../flipCoin.helper'

export const placeBetFlipCoin = createAsyncThunk(
  'flip-coin/place-bet-flip-coin-game',
  async ({ onSuccess, isDemoGame, ...data }, thunkApi) => {
    try {
      let res
      if (isDemoGame) {
        res = await flipCoinDemoPlaceBetHelper(data)
      } else {
        res = await placeBetFlipCoinGameService(data)
      }
      if (res) {
        onSuccess()
        startFlip()
      }
      openSuccessToaster({
        message: 'Bet Placed successfully'
      })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const getFlipCoinBets = createAsyncThunk(
  'flip-coin/myBets',
  async (data, thunkApi) => {
    try {
      const res = await getMyBetsService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)
